import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tab-content',
  template: `<ng-container *ngFor="let tab of tabs">
  <ngb-tab id="{{ tab.id }}">
    <ng-template ngbTabTitle>
      <button class="btn-tab">
        <b>{{ tab.title }}</b>
      </button>
    </ng-template>
    <ng-template ngbTabContent>
      <div class="row justify-content-end">
        <button class="btn btn-dark" type="button" (click)="pageCallback.emit()"><i class="ti-reload"></i>&nbsp; Rafraîchir</button>
        &nbsp;
        <input type="text" [(ngModel)]="filter" placeholder="🔍 Recherche..." class="form-control" style="width: 300px;" />
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-table [analyse]="analyse" [tab]="tab" [filter]="filter" (pageChange)="pageChange.emit($event)" [user]="user"></app-table>
        </div>
      </div>
    </ng-template>
  </ngb-tab>
</ng-container>
`,
})

export class TabContentComponent {
  @Input() tabs: any[];
  @Input() analyse: any;
  @Input() user: any;
  @Output() pageCallback = new EventEmitter();
  @Output() pageChange = new EventEmitter<any>();
  @Input() filter: string;
}